
/** Using the following base images, generate a url for each size used in the application
 *
 * Generating the url can be done by feeding size string (ex: 'w=256,h=144,crop=focus') into a sha256
 *  generator tool using the private key which can be found in the config for startcontentservice
 */
const
	CATEGORY_PLACEHOLDERS = {
		news: 'https://vam-image.imds-cdn.com/1f/18/1f18638f58309fab60bbf0847372eaf7458c08cb',
		entertainment: 'https://vam-image.imds-cdn.com/62/f6/62f6057a05fdd394ebe39e4466dc5dde7cbda056',
		business: 'https://vam-image.imds-cdn.com/2f/c9/2fc915bb496eea9307ef5e475ed6fa6e934a9370',
		sports: 'https://vam-image.imds-cdn.com/a6/cf/a6cf9a09aa850d251a0262f72f972caade9ab37f',
		default: 'https://vam-image.imds-cdn.com/1f/18/1f18638f58309fab60bbf0847372eaf7458c08cb'
	},
	SIZE_MODIFIERS = {
		'w=256,h=144': '/w=256,h=144,crop=auto/?app=portal&sig=d55cbb425be80a60662ff5e449353f5fa17613244f99d3e4baa210ac8e2c4e77',
		'w=300,h=169': '/w=300,h=169,crop=auto/?app=portal&sig=d94eae77037e98965cf2beeb4730cf8215c7aec5cea79a3325a07d83553b425f',
		'w=400,h=300': '/w=400,h=300,crop=auto/?app=portal&sig=47e6d50d82da772f55001fe2b2ebd3e09e1761d9f1b0b1a6390cc91d5933ef6a',
		'w=640,h=360': '/w=640,h=360,crop=auto/?app=portal&sig=cbcf83f15f5e5adab555d14df241b28086396e4ea2736bb1a3843069b8aa066f'
	}
;

export function getPlaceholder(imageRole, imageCategory) {
	if (!SIZE_MODIFIERS[imageRole]) return '';

	let baseUrl = CATEGORY_PLACEHOLDERS[imageCategory] || CATEGORY_PLACEHOLDERS.default;
	return baseUrl + SIZE_MODIFIERS[imageRole];
}

export function imageError(imageRole, imageCategory, e) {
	e.target.onerror = null;
	e.target.src = getPlaceholder(imageRole, imageCategory);
}

export function getImageSrc(images, imageRole, usePlaceholder, imageCategory) {
	if (Array.isArray(images) && images.length > 0) {
		for (let i=0; i<images.length; i++) {
			if (images[i].role === imageRole || images[i].role === 'Dominate') {
				return images[i].src;
			}
		}
	}

	if (usePlaceholder) return getPlaceholder(imageRole, imageCategory);

	return '';
}
